const planPageBaseLayer = {
  page: '/pyme/precios-y-planes',
  page_title: 'Pyme - Precios y planes',
};

const planPageEvents = {
  home: {
    ...planPageBaseLayer,
    action_type: 'Pageview',
    action: 'PYME – Precios y planes',
  },
  clickQuoteHero: {
    ...planPageBaseLayer,
    action_type: 'click',
    action: 'Click link Cotiza ahora – Precios y planes',
  },
  clickPlanDetails: (details: string) => {
    return {
      ...planPageBaseLayer,
      action_type: 'click',
      action: `Click link ${details} Ver más detalles del plan – Precios y planes`,
    };
  },
  hiringFloatClick: {
    ...planPageBaseLayer,
    action_type: 'click',
    action: 'Click link Cotiza online – Precios y planes – Pop-up',
  },
  moreCoverageClick: (coverage: string) => {
    return {
      ...planPageBaseLayer,
      action_type: 'click',
      action: `Click link Ver coberturas – Precios y planes – ${coverage}`,
    };
  },
  downloadClick: (name: string) => {
    return {
      ...planPageBaseLayer,
      action_type: 'click',
      action: `Click link Descarga ${name} – Precios y planes`,
    };
  },
  quoteFooter: {
    ...planPageBaseLayer,
    action_type: 'click',
    action: 'Click link Cotiza ahora footer – Precios y planes',
  },
};

export { planPageBaseLayer, planPageEvents };
